module.exports = __webpack_public_path__ + "img/quizzz-4.0e17b798.jpg";